import * as React from 'react';
import { FunctionalityAccessRight } from '../types/user';

type AccessRightsContextType = {
  functionalityAccessRights?: FunctionalityAccessRight[];
};

export const AccessRightsContext = React.createContext<AccessRightsContextType>({ functionalityAccessRights: [] });
